"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = require("styled-components"); // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//


var style = function style(p) {
  return p.disabled ? (0, _styledComponents.css)(["cursor:not-allowed;color:", ";background-color:", ";&:hover,&:focus{color:", ";background-color:", ";}"], p.theme.colorTextButtonSecondaryDisabled, p.theme.colorBackgroundButtonSecondaryDisabled, p.theme.colorTextButtonSecondaryDisabled, p.theme.colorBackgroundButtonSecondaryDisabled) : (0, _styledComponents.css)(["color:", ";background-color:", ";&:hover,&:focus{color:", ";background:", ";}"], p.theme.colorTextButtonSecondary, p.theme.colorBackgroundButtonSecondary, p.theme.colorTextButtonSecondary, p.theme.colorBackgroundButtonSecondaryHover);
};

var _default = style;
exports["default"] = _default;